// @vue/component


export default {
  name: 'FaqPage',
  data() {
    return {
      faqs: [],
      activeFaq: 0,
      isLoading: false,
    };
  },

  async created() {
    this.isLoading = true;
    await this.$store.dispatch('user/faq/getUserFaq');
    this.faqs = this.$store.getters['user/faq/faqsForUser'];
    this.isLoading = false;
  },
};
